export default "__VITE_ASSET__DTy$87Xw__"